import { type FC } from 'react';
import type { UserSessionData } from '@cencosud-cencommerce/paris-login';
import { Alert, Text } from '@cencosud-cencommerce/paris-uikit';

import { type IdentificationDocumentType } from '@/modules/shared/types/IdentificationDocumentType';
import {
  AddressDetails,
  CustomerInformation,
  RegionAndCommune,
  SaveAddress,
  useFormFieldRefs
} from '@/sections/address/components/AddressForm';
import {
  FORM_CHECK_MESSAGE,
  FORM_CHECK_TITLE,
  FORM_LABEL
} from '@/sections/address/components/AddressForm/constants';

interface Props {
  'data-testid'?: string;
  isEdit?: boolean;
  documentType?: IdentificationDocumentType;
  isDniEnabled?: boolean;
}

const sessionData = localStorage.getItem('sessionData');

export const AddressForm: FC<Props> = (props) => {
  const { 'data-testid': dataTestId = 'paris-addressform' } = props;
  const { isEdit = false, isDniEnabled = false } = props;

  const userData: UserSessionData | undefined = sessionData
    ? JSON.parse(sessionData)
    : undefined;

  const formRefs = useFormFieldRefs();

  return (
    <div className="co-flex co-flex-col co-gap-6" data-testid={dataTestId}>
      <div className="co-flex co-gap-6 co-flex-col">
        <Text className="co-text-right" variant="caption">
          {FORM_LABEL}
        </Text>

        <RegionAndCommune />
        <AddressDetails {...formRefs} />
      </div>

      <CustomerInformation isDniEnabled={isDniEnabled} />

      {userData?.email && !isEdit && <SaveAddress />}

      <Alert title={FORM_CHECK_TITLE} body={FORM_CHECK_MESSAGE} status="info" />
    </div>
  );
};

AddressForm.displayName = 'AddressForm';

export default AddressForm;
